const KEY = "ozy_consent";
const MAX_AGE = 1000 * 60 * 60 * 24 * 182; // 6 months, then ask again
export const OPEN_EVENT = "ozy:open-cookies";

export function readConsent() {
  try {
    const c = JSON.parse(localStorage.getItem(KEY) || "null");
    return c && Date.now() - c.at < MAX_AGE ? c : null;
  } catch {
    return null;
  }
}

export function saveConsent(analytics) {
  localStorage.setItem(KEY, JSON.stringify({ analytics, at: Date.now() }));
  if (analytics) {
    window.__ozyLoadAnalytics?.();
    window.__ozyLoadAds?.();
    window.posthog?.opt_in_capturing?.();
  } else {
    localStorage.removeItem("ozy_src");
    window.posthog?.opt_out_capturing?.();
    window.posthog?.stopSessionRecording?.();
  }
}

export const openCookieSettings = () => window.dispatchEvent(new Event(OPEN_EVENT));
